<template>
  <div
    class="relative"
  >
    <aha-button
      :disabled="isPlanFree"
      :size="size"
      class="button-bg-white w-full"
      :variant="'base'"
      @click="handleExport('excel')"
    >
      <span>
        <span class="flex justify-center items-center">
          <img v-if="!isLoadingExport" src="@/assets/images/icon/excel-icon.svg" class="mr-2">
          <span v-if="!isLoadingExport">  {{ $i18nPresenter.t('Export') }}</span>
          <span v-if="isLoadingExport">{{ $i18nPresenter.t('Exporting...') }}</span>
          <aha-spinner class="ml-2" v-if="isLoadingExport" />
        </span>
      </span>
    </aha-button>
    <span class="  icon-pro">
      <img
        class="icon-audio-pro"
        src="@/assets/images/pro.svg"
        v-if="isPlanFree"
        @click="openUpgradePro('EXPORT_COMBINE')"
      />
      <PlanUpgradeModal
        v-if=" currentUser.id"
        planForFeature="Essential"
        :popup="'left'"
        :is-show-tooltip="ctaUpgradePro"
        :name-feature="'Result'"
        @outsideEvent="clickOutsideUpgrade"
      />
      <div v-if="ctaUpgradePro" class="upgrade-arrow upgrade-arrow_slide"></div>
    </span>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import Config from '@/config'
import Utils from '@/util'
import constants from '@/constant'
import ReportMixin from '@/components-v2/presentation-report/ReportMixin'
import PlanUpgradeModal from '@/components-v2/presentation-editor/editor-header/PlanUpgrade.vue'
import socket from '@/socket'
import VueToastedUtils from '@/utils/vue-toasted.utils'

const { eventCategories } = constants

const FEATURE_TYPE = {
  EXPORT_EXCEL: 'Export to Excel',
  EXPORT_PDF: 'Export to PDF/JPG',
  EXPORT_COMBINE: 'Export',
}

/**
 * @deprecated Use ExportSectionV2 instead
 */
export default {
  components: {
    PlanUpgradeModal,
  },
  mixins: [ReportMixin],
  props: {
    size: {
      type: String,
      default: 'md',
    },
  },
  data() {
    return {
      isShowDownloadSection: false,
      linkDownload: '',
      loading: false,
      loadingClearData: false,
      loadingDuplicate: false,
      loadingExportPdf: false,
      loadingExportExcel: false,
      isShowReport: false,
      ctaUpgradePro: false,
      exportDonePdf: false,
      exportDoneImage: false,
      exportDoneExcel: false,
      role: constants.role,
    }
  },
  computed: {
    ...mapGetters('presentationReport', [
      'engagementRate',
      'presentationReport',
      'engagementLevel',
      'isLoadingReport',
    ]),
    ...mapState({
      isGuestUser: (state) => state.currentUser.isGuest,
      currentUser: (state) => state.currentUser,
      presentation: (state) => state.presentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      loadingExportImage: (state) => state.loadingExportImage,
      loadingExportPdfV2: (state) => state.loadingExportPdfV2,
      loadingExportExcelV2: (state) => state.loadingExportExcelV2,
      canEditPresentation: (state) => state.canEditPresentation,
    }),
    exportPdfInProgress() {
      return this.$store.state.presentation.exportData
          && this.$store.state.presentation.exportData.status === 'processing'
          && this.$store.state.presentation.exportData.requestAt > Date.now() - 30 * 60000
    },
    exportExcelInProgress() {
      return this.$store.state.presentation.exportData
          && this.$store.state.presentation.exportData.excelStatus === 'processing'
          && this.$store.state.presentation.exportData.excelRequestAt > Date.now() - 30 * 60000
    },
    isNotFreeUser() {
      return this.currentUser.plan !== 'free'
    },
    isPlanFree() {
      return !this.$store.state.plan || this.$store.state.plan.group === 'free'
    },
    isLoadingExport() {
      return this.loadingExportExcelV2 || this.loadingExportImage || this.loadingExportPdfV2
    },
  },
  mounted() {
    if (this.skipParentMounted) {
      return
    }

    if (this.isNotFreeUser) {
      this.updateCurrentUserAction({
        hasExport: true,
      })
    }
    this.selectPresentationAction({
      presentation: this.presentation,
    })

    if (this.exportPdfInProgress) {
      this.setLoadingExportPdfAction(true)
      this.setLoadingExportImageAction(true)
    }
    if (this.exportExcelInProgress) {
      this.setLoadingExportExcelAction(true)
    }
  },
  destroyed() {
    if (this.skipParentDestroyed) {
      return
    }
    this.clearPresentationReportAction()
    Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_REPORT, 'Results menu > Report > Close results menu & hide report')
  },
  methods: {
    ...mapActions('presentationReport', [
      'selectPresentationAction',
      'openReportPanelAction',
      'clearPresentationReportAction',
      'generateReportAction',
      'subscribeReportAction',
    ]),
    ...mapActions(['updateCurrentUserAction', 'setLoadingExportPdfAction', 'setLoadingExportImageAction', 'setLoadingExportExcelAction']),
    async handleExport(type) {
      this.isShowDownloadSection = !this.isShowDownloadSection
      VueToastedUtils.showToast(this.$i18nPresenter.t('Generating report...'), {}, {
        className: ['custom-toast__loading'],
        hasReturnValue: true,
        action: {
          class: 'custom-toast__loading-url',
        },
      })

      if (type === 'excel') await this.exportExcel()
    },

    async exportExcel() {
      if (this.isPlanFree) {
        this.openUpgradePro('EXPORT_COMBINE')
        return
      }

      const isDisable = this.loadingExportExcelV2 || this.exportExcelInProgress
      if (isDisable) return
      if (this.loadingExportPdf) return
      if (this.loadingExportExcel || this.exportExcelInProgress || this.loadingExportExcelV2) return
      this.loadingExportExcel = true
      this.setLoadingExportExcelAction(true)
      this.$store.state.exportingType = 'excel'
      this.exportDoneExcel = false
      Utils.trackGA4AndMixpanel(eventCategories.PRESENTATION_REPORT, {
        eventAction: 'Result > Download report > Select Download Format',
        eventLabel: 'Spreadsheet',
        eventCategory: eventCategories.PRESENTATION_REPORT,
        ...this.reportMetricField(),
      })
      this.$http.post(Config.workerApi.exportExcel, {
        id: this.$store.state.presentation.id,
        socketId: socket.getSocketId(),
      }).then(() => {
        const exportData = {
          ...this.$store.state.presentation.exportData,
          excelStatus: 'processing',
          excelRequestAt: Date.now(),
        }
        this.$store.dispatch('onlyPatchPresentationAction', { exportData })

        this.loadingExportExcel = false
        Utils.mixpanelTracking(eventCategories.PRESENTATION_REPORT, 'Results menu > Export Excel > Success')
      },
      (err) => {
        const exportData = { ...this.$store.state.presentation.exportData, excelStatus: 'failure' }

        this.$store.dispatch('onlyPatchPresentationAction', { exportData })

        this.loadingExportExcel = false
        this.setLoadingExportExcelAction(false)
        this.$store.state.exportingType = null
        Utils.mixpanelTracking(eventCategories.PRESENTATION_REPORT, 'Results menu > Export Excel > Failed', `Request Export Spreadsheet fail ${JSON.stringify(err)}`)
      })
    },
    openUpgradePro(featureType = FEATURE_TYPE.EXPORT_COMBINE) {
      this.ctaUpgradePro = true

      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_REPORT,
        'Feature upgrade',
        `${FEATURE_TYPE[featureType]}`,
      )
    },

    clickOutsideUpgrade() {
      this.ctaUpgradePro = false
    },
  },
}
</script>

<style lang="scss" scoped>
.overlay-disable-section {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full z-20;
}
.icon-pro{
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
  cursor: pointer;
  transform: translate(50%, -50%);
}
.result-header {
  @apply sticky top-0 z-20 flex items-center justify-center h-16;
  @apply p-4 shadow-top bg-base-0 border-base-30 text-base-90;
}
.wrapper-list{
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 224px;
  .item-export{
    transition: 0.1s;
    &:hover{
      background: #F5F5F5;
    }
    border-radius: 4px;
    cursor: pointer;
    display: grid;
    grid-template-columns: 20px auto;
    align-items: center;
    padding: 8px;
    gap: 8px;
    img{
      width: 20px;
    }
    font-size: 14px;
  }

}

.cta-upgrade {
  @apply bg-secondary-100 absolute w-60 p-3 rounded z-50;
  left: -10px;
  top: 1.5rem;
  font-family: 'Nunito', sans-serif;
  padding-bottom: 16px;

  div,
  span {
    @apply text-base-0 text-sm;
  }

  div {
    @apply font-bold;
  }

  span {
    @apply font-normal mt-1;
  }
}

.upgrade-arrow {
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent rgba(40, 46, 62, var(--tw-bg-opacity)) transparent;
  border-style: solid;
  position: absolute;
  z-index: 1;
  top: 2rem;

  &.upgrade-arrow_presentation {
    left: calc(50% - 47px);
  }

  &.upgrade-arrow_slide {
    left: calc(50% - 8px);
  }
}

.tooltip-audio-upgrade-now {
  .button-upgrade-now {
    margin-top: 12px;
  }
}

h5.custom-title {
  border-left: 4px solid transparent;
}
.aha-button-base{
  background: white;
}

.export-list {
  ul {
    padding: 0 20px;

    li {
      border-width: 1px;
      position: relative;
      padding: 12px;
      border-radius: 4px;
      margin-bottom: 16px;
      cursor: pointer;
      color: #313131;

      .loading {
        position: absolute;
        right: 16px;
        margin: 0 auto;
        top: 20px;
        width: auto;
      }

      .fa-download {
        display: none;
      }

      &:hover {
        .fa-download {
          display: block;
        }
      }
    }
  }

  .disabled-cursor {
    cursor: not-allowed;
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));;
    @apply border-base-30;
    &:hover {
      .fa-download {
        display: none;
      }
    }
  }

  &.disabled {
    ul {
      li {
        cursor: not-allowed;
        @apply bg-base-10 text-base-70;
        i {
          @apply text-base-70;
        }
      }
    }
  }
}

</style>
